import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import OtpResumeLogin from "@/src_new/features/auth/components/otp/OtpResumeLogin";
import { App_Url_New } from "@/src_new/shared/common/static";
import { setQuoteFlowSessionData } from "@/src_new/shared/redux/reducers/quoteFlowSlice";
import { usePosterReducers } from "@/src_new/shared/redux/store/useGetData";
import { setSession } from "../redux/reducers/authSlice";
import { closeModal } from "../redux/reducers/uiSlice";
import { AppDispatch } from "../redux/store/store";
import CommonPopup from "./CommonPopup";

const authPopupKeys = new Set<string>([
  App_Url_New.PopupKeys.AUTH_RETAIL_LOGIN,
  App_Url_New.PopupKeys.AUTH_CAR_QUOTE_RESUME,
  App_Url_New.PopupKeys.AUTH_TRAVEL_QUOTE_RESUME,
]);

export default function CommonPopupHost() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const {
    ui: {
      status,
      data,
      key,
      onClose,
      title,
      children,
      className,
      header,
      outerClassName,
      form,
      formLoading,
      url,
    },
  } = usePosterReducers();
  const isOpen = status === App_Url_New.PopUpStatus.SHOW;
  const popupData = data ?? {};
  const isAuthPopup = Boolean(key && authPopupKeys.has(key));

  const handleClose = () => {
    onClose?.(key);
    dispatch(closeModal());
  };

  if (!isOpen || !key) return null;

  const content = isAuthPopup ? (
    <OtpResumeLogin
      isOpen={isOpen}
      onClose={handleClose}
      showUserLoginForm={popupData.showUserLoginForm}
      emailAddress={popupData.emailAddress}
      phoneNumber={popupData.phoneNumber}
      fallbackClientId={popupData.fallbackClientId}
      initialMessage={popupData.initialMessage}
      title={popupData.title}
      validationType={popupData.validationType ?? "auto"}
      autoRedirect={popupData.autoRedirect ?? false}
      renderInline
      onSessionResolved={async (sessionData) => {
        if (
          key === App_Url_New.PopupKeys.AUTH_CAR_QUOTE_RESUME ||
          key === App_Url_New.PopupKeys.AUTH_TRAVEL_QUOTE_RESUME
        ) {
          const normalizedSession = {
            client: sessionData.client,
            session_data: sessionData,
          };

          dispatch(setSession(normalizedSession));
          dispatch(setQuoteFlowSessionData(normalizedSession));
        }

        dispatch(closeModal());

        if (url) {
          navigate(url, { replace: true });
          return;
        }

        if (popupData.showUserLoginForm) {
          navigate(App_Url_New.retail.frontlinks.retail_dashboard, { replace: true });
        }
      }}
    />
  ) : (
    children
  );

  return (
    <CommonPopup
      isOpen={isOpen}
      name={key}
      title={title}
      header={header}
      className={className}
      outerClassName={outerClassName}
      // bodyClassName={bodyClassName}
      // closeOnOverlayClick={closeOnOverlayClick}
      // showCloseButton={isAuthPopup ? false : showCloseButton}
      onClose={handleClose}
    >
      {content}
    </CommonPopup>
  );
}
